import { ORDER_PAYMENT_TYPE } from './constants';

export const getPaymentMethodUsedByCustomer = (paymentFlag) => {
  if (paymentFlag === ORDER_PAYMENT_TYPE.POSTPAID) return 'cod';
  if (paymentFlag === ORDER_PAYMENT_TYPE.PREPAID) return 'prepaid';
  return 'both';
};
